var _path, _path2, _circle, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcResServiceAutoReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.792 18.0417C34.792 18.2853 34.8085 18.5281 34.8416 18.7701C34.8748 19.0121 34.9314 19.2506 35.0115 19.4857C35.0649 19.663 35.0593 19.8326 34.9947 19.9945C34.93 20.1563 34.8203 20.2725 34.6654 20.343C34.5019 20.4221 34.3392 20.4285 34.1774 20.3622C34.0155 20.296 33.9079 20.1742 33.8545 19.9969C33.7434 19.6828 33.6635 19.3604 33.6149 19.0297C33.5663 18.699 33.542 18.3697 33.542 18.0417C33.542 16.2394 34.1691 14.7055 35.4234 13.44C36.6777 12.1745 38.2033 11.5418 40.0003 11.5418H40.651L39.5484 10.4392C39.433 10.3238 39.374 10.1788 39.3713 10.0041C39.3686 9.8294 39.4277 9.68171 39.5484 9.56099C39.6691 9.44025 39.8155 9.37988 39.9875 9.37988C40.1595 9.37988 40.3059 9.44025 40.4266 9.56099L42.5051 11.6395C42.6557 11.7901 42.7311 11.9659 42.7311 12.1667C42.7311 12.3676 42.6557 12.5433 42.5051 12.694L40.4266 14.7725C40.3112 14.8879 40.1662 14.9469 39.9915 14.9496C39.8168 14.9523 39.6691 14.8932 39.5484 14.7725C39.4277 14.6518 39.3673 14.5054 39.3673 14.3334C39.3673 14.1614 39.4277 14.015 39.5484 13.8943L40.651 12.7917H40.0003C38.5527 12.7917 37.3227 13.3013 36.3104 14.3206C35.2981 15.3398 34.792 16.5802 34.792 18.0417ZM45.2087 17.9584C45.2087 17.7148 45.1921 17.472 45.159 17.23C45.1258 16.988 45.0692 16.7495 44.9891 16.5145C44.9357 16.3371 44.9413 16.1675 45.0059 16.0057C45.0706 15.8438 45.1803 15.7276 45.3352 15.6571C45.4987 15.5781 45.66 15.5717 45.8192 15.6379C45.9784 15.7041 46.0847 15.8259 46.1381 16.0033C46.2492 16.3174 46.3304 16.6398 46.3817 16.9704C46.433 17.3011 46.4586 17.6304 46.4586 17.9584C46.4586 19.7607 45.8315 21.2947 44.5772 22.5602C43.3229 23.8256 41.7973 24.4584 40.0003 24.4584H39.3496L40.4522 25.561C40.5676 25.6764 40.6266 25.8214 40.6293 25.9961C40.632 26.1707 40.5729 26.3184 40.4522 26.4392C40.3315 26.5599 40.1851 26.6203 40.0131 26.6203C39.8411 26.6203 39.6948 26.5599 39.574 26.4392L37.4955 24.3607C37.3449 24.21 37.2696 24.0342 37.2696 23.8334C37.2696 23.6326 37.3449 23.4568 37.4955 23.3062L39.574 21.2277C39.6894 21.1123 39.8344 21.0532 40.0091 21.0506C40.1838 21.0479 40.3315 21.1069 40.4522 21.2277C40.5729 21.3484 40.6333 21.4947 40.6333 21.6667C40.6333 21.8387 40.5729 21.9851 40.4522 22.1058L39.3496 23.2084H40.0003C41.448 23.2084 42.6779 22.6988 43.6902 21.6796C44.7025 20.6603 45.2087 19.4199 45.2087 17.9584Z",
    fill: "#2E2E30",
    stroke: "#2E2E30",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2002 38.9502C18.2002 35.0842 21.3342 31.9502 25.2002 31.9502H55.2002C59.0662 31.9502 62.2002 35.0842 62.2002 38.9502V60.0002C62.2002 63.8662 59.0662 67.0002 55.2002 67.0002H25.2002C21.3342 67.0002 18.2002 63.8662 18.2002 60.0002V38.9502Z",
    fill: "white",
    stroke: "#2E2E30",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 54,
    r: 7,
    fill: "#D5D4FF",
    stroke: "#2E2E30",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 53.913L38.7011 55.6388C38.8969 55.8374 39.2174 55.8374 39.4132 55.6388L43 52",
    stroke: "#2E2E30",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2002 38.9502C18.2002 35.0842 21.3342 31.9502 25.2002 31.9502H55.2002C59.0662 31.9502 62.2002 35.0842 62.2002 38.9502V41.9502H18.2002V38.9502Z",
    fill: "#D5D5FF",
    stroke: "#2E2E30",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 30V34",
    stroke: "#2E2E30",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30V34",
    stroke: "#2E2E30",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcResServiceAutoReceipt);
export default __webpack_public_path__ + "static/media/ic_res_service_auto_receipt.8bfe881aefcdf1f174d9e679bb8b94b5.svg";
export { ForwardRef as ReactComponent };